import { Injectable } from '@angular/core'
import { BaseService } from '@appService/base.service'
import { BehaviorSubject, Observable, Subject } from 'rxjs'
import { ResponseModel } from '../api-response.model'

@Injectable({
  providedIn: 'root'
})
export class MenuService extends BaseService {
  contextPath = '/api/v1/admin/menu'
  menuObs = new BehaviorSubject<any[]>([])

  // xoá tính năng khỏi chức năng
  deleteFunctionMenu(param: any): Observable<ResponseModel<boolean>> {
    return this.post(`${this.contextPath}/remove-function-menu`, param)
  }

  // Xóa nhiều chức năng
  deleteMenuByIds(ids: any): Observable<ResponseModel<any[]>> {
    return this.post(`${this.contextPath}/delete-menu`, ids)
  }

  // Lấy thông tin chức năng
  getMenuById(id: any): Observable<ResponseModel<any[]>> {
    return this.get(`${this.contextPath}/get-menu/${id}`, {})
  }

  // Cập nhật chức năng
  updateMenu(payload: any): Observable<ResponseModel<any[]>> {
    return this.post(`${this.contextPath}/update-menu`, payload)
  }

  // gán tính năng vào chức năng
  addFunctionMenu(param: any): Observable<ResponseModel<boolean>> {
    return this.post(`${this.contextPath}/add-function-menu`, param)
  }
}
